import React from 'react';
import {
  Container,
  Row,
  Col,
} from "reactstrap";
import { Link } from 'react-router-dom';
import './ProductSelection.css';
import '../../views/Index.css';
import carDecal from '../../assets/img/carDecal.webp';
import carMagnet from '../../assets/img/carMagnet2.webp';
import acrylic from '../../assets/img/acrylic.webp';
import stamp from '../../assets/img/quill_stamp2.webp';
import golfballmarker from '../../assets/img/golfballmarker1.webp';

const products = [
  {
    id: 'acrylic',
    name: 'Acrylic',
    image: acrylic,
    description: 'High-quality acrylic sign for indoor/outdoor use',
  },
  {
    id: 'cardecal',
    name: 'Car Decal',
    image: carDecal,
    description: 'Durable vinyl decal for your vehicle',
  },
  {
    id: 'magnet',
    name: 'Magnet',
    image: carMagnet,
    description: 'Removable magnetic',
  },
  {
    id: 'stamp',
    name: 'Ink Stamp',
    image: stamp,
    description: 'Self-Inking Quill Stamp',
  },
  {
    id: 'golfBallMarker',
    name: 'Golf Ball Marker',
    image: golfballmarker,
    description: 'Golf Ball Marker, Silver, Regular size',
  },
];

const ProductSelection = ({ guuid, qrColor, logoColor, friendlyName, shortId }) => {
  return (
    <Container fluid className="mt-6 mb-3">
      <Row className="justify-content-center gx-2">
        {products.map((product) => (
          <Col
            key={product.id}
            xs="6"
            sm="6"
            md="4"
            className="mb-4 px-4 d-flex justify-content-center"
          >
            <Link
              to={`/product/${product.id}`}
              state={{ guuid, qrColor, logoColor, friendlyName, shortId }} 
              className="product-option text-decoration-none text-center"
            >
            <img
              className="store-img mb-2"
              src={product.image}
              alt={product.name}
              style={{
                width: '160px',
                height: '160px',
                objectFit: 'cover',
                borderRadius: '0.5rem',
              }}
            />
              <p className="text-white mt-1">{product.name}</p>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ProductSelection;
